import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { nodeInventoryApiRef } from './api/types';
import { NodeInventoryClient } from './api/NodeInventoryClient';

const nodeInventoryApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: nodeInventoryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new NodeInventoryClient({ discoveryApi, fetchApi }),
    }),
});

const nodeInventoryPage = PageBlueprint.make({
  params: {
    path: '/node-inventory',
    title: 'Node Inventory',
    routeRef: rootRouteRef,
    // The page renders its own BUI <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/NodeInventoryPage').then(m => (
        <m.NodeInventoryPage />
      )),
  },
});

export const nodeInventoryPlugin = createFrontendPlugin({
  pluginId: 'node-inventory',
  title: 'Node Inventory',
  routes: {
    root: rootRouteRef,
  },
  extensions: [nodeInventoryApi, nodeInventoryPage],
});

export default nodeInventoryPlugin;
